import CompaniesSlider from "../../../components/companies-slider";
import ModalForm from "../../../components/base/forms/modal-form";

export default class PageModule {
    constructor() {
        this.initCompaniesSlider();
        this.initPartnershipForm();
    }

    initCompaniesSlider() {
        this.companiesSlider = new CompaniesSlider();
    }

    initPartnershipForm() {
        const id = 'partnership';
        const $triggers = document.querySelectorAll(`[data-modal="${id}"]`);

        if ($triggers && $triggers.length) {
            try	{
                this.consultationForm = new ModalForm({
                    formId: id,
                    uri: '/1.0/b2b/partnership',
                    $modalTriggers: [$triggers[0], $triggers[1]]
                });
            } catch (err) {
                console.error('Partnership Form:', err);
            }
        }
    }
}